import React from 'react';
import { can, PERMISSIONS } from '../../utils/permissions';

const AssetRowActions = ({
  assetId,
  asset,
  onView,
  onEdit,
  onDelete,
  onCheckout,
  onCheckin,
  onRemind,
  actionFlags,
}) => {
  const status = asset?.status || 'available';

  const allowView =
    actionFlags?.view ?? (can(PERMISSIONS.VIEW_ALL_ASSETS) || can(PERMISSIONS.VIEW_ASSIGNED_ASSETS));
  const allowEdit = actionFlags?.edit ?? can(PERMISSIONS.EDIT_ASSETS);
  const allowCheckout = actionFlags?.checkout ?? can(PERMISSIONS.CHECKOUT);
  const allowCheckin = actionFlags?.checkin ?? can(PERMISSIONS.CHECKIN);
  const allowRemind = actionFlags?.remind ?? can(PERMISSIONS.CHECKOUT);
  const allowDelete = actionFlags?.delete ?? can(PERMISSIONS.DELETE_ASSETS);

  return (
    <div className="asset-row-actions" style={{ display: 'flex', gap: '6px', justifyContent: 'center', flexWrap: 'nowrap' }}>
      {allowView && (
        <button
          onClick={() => onView && onView(assetId)}
          style={{
            padding: '6px 12px',
            background: '#edf2f7',
            color: '#4a5568',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '11px',
            fontWeight: 500
          }}
          title="View"
        >
          👁️
        </button>
      )}
      {allowEdit && (
        <button
          onClick={() => onEdit && onEdit(assetId)}
          style={{
            padding: '6px 12px',
            background: '#e6fffa',
            color: '#234e52',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '11px',
            fontWeight: 500
          }}
          title="Edit"
        >
          ✏️
        </button>
      )}
      {/* Checkout button - show for available assets */}
      {status === 'available' && onCheckout && allowCheckout && (
        <button
          onClick={() => onCheckout(asset)}
          style={{
            padding: '6px 12px',
            background: '#667eea',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '11px',
            fontWeight: 500
          }}
          title="Checkout"
        >
          📤
        </button>
      )}
      {/* Checkin button - show for received and issue_reported assets */}
      {(status === 'received' || status === 'issue_reported') && onCheckin && allowCheckin && (
        <button
          onClick={() => onCheckin(asset)}
          style={{
            padding: '6px 12px',
            background: '#48bb78',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '11px',
            fontWeight: 500
          }}
          title="Checkin"
        >
          📥
        </button>
      )}
      {/* Remind: same gate as checkout (handover / assignment flow) */}
      {(status === 'pending' || status === 'in_transfer') && onRemind && allowRemind && (
        <button
          onClick={() => onRemind(asset)}
          style={{
            padding: '6px 12px',
            background: '#edf2f7',
            color: '#4a5568',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '11px',
            fontWeight: 500
          }}
          title="Send Reminder Email"
        >
          📧
        </button>
      )}
      {allowDelete && (
        <button
          onClick={() => onDelete && onDelete(assetId)}
          style={{
            padding: '6px 12px',
            background: '#fed7d7',
            color: '#c53030',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '11px',
            fontWeight: 500
          }}
          title="Delete"
        >
          🗑️
        </button>
      )}
    </div>
  );
};

export default AssetRowActions;

